import React, {Dispatch, useState} from "react";

export const usePagination = <T>(
  setData: Dispatch<React.SetStateAction<T[]>>,
  setHasMore: Dispatch<React.SetStateAction<boolean>>,
  hasMore: boolean = true,
  initialPage: number = 1,
  limit: number = 10
) => {
  const [page, setPage] = useState<number>(initialPage);

  const appendNextPage = async(
    fetch: ({page, limit}: {page: number; limit: number}) => Promise<T[]>,
    mutation?: (data: T) => T
  ) => {
    if(!hasMore) return;

    const newPage = page + 1;
    const newData = await fetch({limit, page: newPage});
    const mutatedData = mutation ? newData.map(mutation) : newData;
    setData(prevProjects => {
      prevProjects.push(...mutatedData);
      return prevProjects;
    });

    checkHasMore(mutatedData);

    setPage(newPage);
  };

  const refreshLastPage = async(
    fetch: ({page, limit}: {page: number; limit: number}) => Promise<T[]>,
    mutation?: (data: T) => T
  ) => {
    const newData = await fetch({limit, page});
    const mutatedData = mutation ? newData.map(mutation) : newData;
    setData(prevProjects => {
      const itemsToRemove = prevProjects.length % limit;
      prevProjects.splice(-itemsToRemove, itemsToRemove);
      prevProjects.push(...mutatedData);
      return prevProjects;
    });

    checkHasMore(mutatedData);
  };

  const checkHasMore = <D>(newData: D[]): D[] => {
    if(newData.length < (limit || 10)) setHasMore(false);
    return newData;
  };

  return {
    appendNextPage,
    checkHasMore,
    currentPage: page,
    hasMore,
    refreshLastPage
  };
};
